<template>
    <div class="form-box">
        <div class="form-title text-center">
            验证身份
        </div>
        <div class="form-content">
            <el-form label-width="100px" style="width: 420px;">
                <el-form-item label="">
                    <div class="text-center" style="line-height: 1.5">已向您尾号为{{tail}}的手机号发送验证码 <br>请您输入验证码验证身份</div>
                </el-form-item>
                <el-form-item label="验证码">
                    <el-input v-model="code" placeholder="请输入验证码"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">下一步</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import qs from 'qs'
import router from '@/router'
export default {
    name: 'Step1',
    data () {
        return {
            phone: '',
            code: '',
            tail: '',
            payPWD: -1
        }
    },
    mounted () {
        this.getPhone()
    },
    methods: {
        getPhone () {
            this.phone = JSON.parse(localStorage.getItem('USERINFO')).phone + ''
            this.tail = this.phone.substr(-4)
            this.payPWD = JSON.parse(localStorage.getItem('USERINFO')).is_pay_pwd
            if (this.payPWD === 1) {
                this.sendSMS(4)
            } else {
                this.sendSMS(3)
            }
        },
        sendSMS (type) {
            this.$http.post('/api/sendsms', qs.stringify({
                phone: this.phone,
                type
            }))
                .then(res => {
                    if (res.code === 0) {
                        if (res.data.send_status !== 1) {
                            this.$message.error(res.data.msg)
                        }
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        onSubmit () {
            if (this.code === '') {
                this.$message.error('请输入短信验证码')
            } else {
                this.$http.post('/api/user/resetpaypwd', qs.stringify({
                    code: this.code,
                    type: this.payPWD === 1 ? 1 : 0
                }))
                    .then(res => {
                        if (res.code === 0) {
                            router.replace('/index/info/paypassword/step2')
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.error(err)
                    })
            }
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/sub.scss";
</style>
